export default "__VITE_PUBLIC_ASSET__937e2fba__"